import { render, staticRenderFns } from "./recoverPassword.vue?vue&type=template&id=a2bf9aec&"
import script from "./recoverPassword.vue?vue&type=script&lang=js&"
export * from "./recoverPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports